import {
  CalendarGridHeader as AriaCalendarGridHeader,
  CalendarHeaderCell,
} from 'react-aria-components'

import { typographyStyles } from '../../../structure/typography/styles'

export const CalendarGridHeader = () => (
  <AriaCalendarGridHeader>
    {(day) => (
      <CalendarHeaderCell
        className={typographyStyles({
          intensity: 'tertiary',
          weight: 'bold',
          size: 'xs',
        })}
      >
        {day}
      </CalendarHeaderCell>
    )}
  </AriaCalendarGridHeader>
)
